module.exports = __webpack_public_path__ + "img/propvest_logo_200x150.697e7e93.svg";